import {
    GET_HAPPINESS_TIPS_CATEGORIES,
    GET_STATE_LOADING
} from "./types/getters.js";

const getters = {
    [GET_HAPPINESS_TIPS_CATEGORIES]: state => state.categories,
    [GET_STATE_LOADING]: state => state.loading
};

export default getters;
